import React from "react";
import CryptoConverter from "./CryptoConverter"; 


function App() {
  return (
    <div className="App">
      <CryptoConverter />
    </div>
  );
}

export default App;